import { featuredCategories } from '@/mocks/categories';

export default function FeaturedShowcase() {
  return (
    <section className="bg-background-100 py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-5xl font-heading text-foreground-950 leading-tight mb-3">
            Featured{' '}
            <span className="text-accent-600">Kakobuy Sheet</span>
            {' '}Categories
          </h2>
          <p className="text-sm text-foreground-500 max-w-xl mx-auto">
            Explore our most popular spreadsheet categories — curated collections
            of trending products and community favorites.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
          <div className="lg:row-span-2">
            <a
              href={featuredCategories[0].url}
              target="_blank"
              rel="noopener nofollow"
              className="block group relative rounded-2xl overflow-hidden h-full min-h-[500px] cursor-pointer"
            >
              <img
                src={featuredCategories[0].image}
                alt={featuredCategories[0].name}
                className="absolute inset-0 w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-primary-900/80 via-primary-900/10 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-6 md:p-8">
                <span className="inline-block px-3 py-1 bg-background-50/20 backdrop-blur-sm rounded-full text-xs text-background-50 mb-3">
                  Most Popular
                </span>
                <h3 className="text-2xl md:text-3xl font-heading text-background-50 mb-2">
                  {featuredCategories[0].name}
                </h3>
                <p className="text-sm text-background-50/70 max-w-md">
                  {featuredCategories[0].description}
                </p>
              </div>
            </a>
          </div>

          {featuredCategories.slice(1).map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="block group relative rounded-2xl overflow-hidden h-[240px] cursor-pointer"
            >
              <img
                src={cat.image}
                alt={cat.name}
                className="absolute inset-0 w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-primary-900/60 via-primary-900/5 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                <h3 className="text-xl md:text-2xl font-heading text-background-50 mb-1">
                  {cat.name}
                </h3>
                <p className="text-xs text-background-50/70">{cat.description}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}